import { socket } from "../index";

const emitGetRoomDetail = (
  roomId: string,
) => {
  socket?.emit('GET_ROOM_DETAIL', {
    roomId,
  });
}

export default emitGetRoomDetail;